module.exports = __webpack_public_path__ + "statics/img/MultiWarehouse-2.625ebd87.png";